import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#F5F0E8] border-t border-[#E8E0D6]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <span className="font-cormorant text-3xl text-[#2C2B29] font-semibold tracking-widest">
                MG<span className="text-[#C4A45A]">+</span>
              </span>
              <span className="block text-xs tracking-[0.25em] uppercase font-raleway font-light text-[#8B8680] mt-0.5">
                Saúde &amp; Estética
              </span>
            </div>
            <p className="font-raleway text-sm text-[#8B8680] leading-relaxed max-w-xs mb-5">
              Clínica de estética em Santo André com foco em saúde, bem‑estar e atendimento personalizado no Centro de Santo André – SP.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/mgsaudeeestetica"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="Instagram MG+ Saúde & Estética"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E0D8CE] text-[#8B8680] hover:border-[#C4A45A] hover:text-[#C4A45A] transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="https://wa.me/551122289498"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="WhatsApp MG+ Saúde & Estética"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E0D8CE] text-[#8B8680] hover:border-[#C4A45A] hover:text-[#C4A45A] transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-raleway text-xs tracking-[0.25em] uppercase text-[#2C2B29] font-semibold mb-4">
              <a href="#sobre">Navegação</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: 'Sobre a Clínica', href: '#sobre' },
                { label: 'Tratamentos', href: '#tratamentos' },
                { label: 'Diferenciais', href: '#diferenciais' },
                { label: 'Depoimentos', href: '#depoimentos' },
                { label: 'FAQ', href: '#faq' },
                { label: 'Contato', href: '#contato' },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleNav(link.href)}
                    className="font-raleway text-sm text-[#8B8680] hover:text-[#C4A45A] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-raleway text-xs tracking-[0.25em] uppercase text-[#2C2B29] font-semibold mb-4">
              <a href="#contato">Contato</a>
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#C4A45A] text-sm mt-0.5"></i>
                <span className="font-raleway text-sm text-[#8B8680] leading-relaxed">
                  Rua Primeiro de Maio, 202, Sala 601<br />Centro, Santo André – SP
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-[#C4A45A] text-sm"></i>
                <span className="font-raleway text-sm text-[#8B8680]">Seg–Sex: 09h–18h</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-[#C4A45A] text-sm"></i>
                <span className="font-raleway text-sm text-[#8B8680]">Sáb: 09h–13h</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-[#C4A45A] text-sm"></i>
                <a
                  href="https://wa.me/551122289498"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="font-raleway text-sm text-[#8B8680] hover:text-[#C4A45A] transition-colors cursor-pointer"
                >
                  (11) 2228-9498
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#E0D8CE]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="font-raleway text-xs text-[#B0A89E] text-center sm:text-left">
            © {currentYear} MG+ Saúde &amp; Estética. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center sm:justify-end">
            <Link
              to="/lgpd"
              className="font-raleway text-xs text-[#B0A89E] hover:text-[#C4A45A] transition-colors cursor-pointer whitespace-nowrap"
            >
              Política de Privacidade (LGPD)
            </Link>
            <a
              href="https://www.ovoscomweb.com.br"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-raleway text-xs text-[#B0A89E] hover:text-[#C4A45A] transition-colors cursor-pointer whitespace-nowrap"
            >
              by OvosComWeb
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
